import { ImsObject } from 'app/shared/collections/ims_object';
import { IpDevice } from 'app/shared/collections/ip_device';
import { FieldSchemaUnits } from 'app/shared/collections/StatDefinition';
import { Operator } from 'app/shared/operators';
import {
    IMSValueGetter,
    StatFilterFn,
    StatFilterFnGenerator,
} from '../../value_getters/value_getter';

export class GenericRadioStatValueGetter extends IMSValueGetter {
    constructor(
        statCollection,
        statKey,
        units: FieldSchemaUnits,
        operators: Operator[],
        filterFunctionGenerator: StatFilterFnGenerator = null,
    ) {
        super(statCollection, statKey, units, filterFunctionGenerator, [], operators);
    }

    getValueForStat(stat) {
        if (!stat) {
            return undefined;
        }

        if (stat.resource) {
            return stat.resource[this.statKey];
        }

        return stat[this.statKey];
    }

    _getStatForIPDevice(
        ipDevice: IpDevice,
        time: Cesium.JulianDate,
        statFilterFn: StatFilterFn,
        innerStatFilterFns: StatFilterFn[],
    ): ImsObject[] {
        if (!ipDevice) {
            return [];
        }

        let stats = [];

        // we're filtering by an IP device, but the stats are about Radios
        for (const radio of Object.values(ipDevice.radios) || []) {
            for (const stat of Object.values(this.statCollection.getStats(radio.id, time)) || []) {
                stats.push(stat);
            }
        }

        if (statFilterFn) {
            // apply a filter if need be
            stats = stats.filter(statFilterFn);
        }

        // after each inner stat getter has been applied, innerStats will be the final depth of stats
        return stats;
    }
}
